import { gql } from '@apollo/client';

export const MUTATION_CREATE_PLAN = gql`
  mutation CreatePlan($input: CreatePlanInput!) {
    createPlan(input: $input) {
      id
      name
      description
      price
      periodicity
      is_active
      modules
    }
  }
`;

export const MUTATION_UPDATE_PLAN = gql`
  mutation UpdatePlan($updatePlanId: Float!, $input: UpdatePlanInput!) {
    updatePlan(id: $updatePlanId, input: $input) {
      id
      name
      description
      price
      periodicity
      is_active
      modules
    }
  }
`;

export const MUTATION_DELETE_PLAN = gql`
  mutation DeletePlan($deletePlanId: Float!) {
    deletePlan(id: $deletePlanId) {
      id
      name
      description
      price
      periodicity
      modules
      is_active
    }
  }
`;
